// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"406":"799b8dd5","527":"e084ecdd"}[chunkId] + ".chunk.js");